import { withScope } from '@sentry/react';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

export { captureException } from 'logrocket';

export const initializeLogRocket = (dsn: string) => {
    // LogRocket enabled only when dsn env config is available
    if (dsn !== null) {
        LogRocket.init(dsn, {
            release: import.meta.env.VITE_APP_VERSION,
            shouldDebugLog: false,
        });

        LogRocket.getSessionURL((sessionURL) => {
            withScope((scope) => {
                scope.setContext('session', { url: sessionURL });
            });
        });

        setupLogRocketReact(LogRocket);
    }
};

export const identifyLogRocketUser = (userId: string, traits?) =>
    LogRocket.identify(userId, traits);
